module.exports = __webpack_public_path__ + "static/solfranMockup-14f8a4d8be89540f761ff07d3ca06be0.png";